import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * React Router keeps the window scroll offset across navigations, so following
 * a link could drop you into the middle of the next page — the cart opened
 * 139px down and checkout 235px down.
 *
 * New navigations start at the top; going back or forward keeps the browser's
 * own restored position, which is what a shopper returning to a product list
 * expects. Focus moves to the page heading so keyboard and screen-reader users
 * are told where they landed instead of staying on the old page's controls.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") return;
    window.scrollTo(0, 0);
    const heading = document.querySelector("h1");
    if (!heading) return;
    heading.setAttribute("tabindex", "-1");
    heading.focus({ preventScroll: true });
  }, [pathname, navigationType]);

  return null;
}
